import { msInputStyles, getRem, transitionAnimation, typographyBody1 } from 'lib/core';
import { INPUT_SIZES, inputStateOutlineStyles } from 'lib/input';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const textAreaContentLabelBottomPadding = {
  [INPUT_SIZES.LARGE]: getRem('6px'),
  [INPUT_SIZES.SMALL]: getRem('3px'),
  [INPUT_SIZES.STANDARD]: getRem('6px'),
};

const TextAreaContentLabel = ({
  hasError,
  hideLabel,
  isDisabled,
  isFocused,
  isHighlighted,
  isReadOnly,
  isRequired,
  maxInputHeight,
  size,
  ...other
}) => {
  return (
    <StyledTextAreaContentLabel
      $hasError={hasError}
      $hideLabel={hideLabel}
      $isDisabled={isDisabled}
      $isFocused={isFocused}
      $isHighlighted={isHighlighted}
      $isReadOnly={isReadOnly}
      $isRequired={isRequired}
      $maxInputHeight={maxInputHeight}
      $size={size}
      {...other}
    />
  );
};

const StyledTextAreaContentLabel = styled.label`
  ${({ theme }) => typographyBody1(theme)};
  ${msInputStyles};
  ${transitionAnimation('border, box-shadow')};
  box-sizing: border-box;
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  outline: none;
  padding: 0;
  padding-bottom: ${({ $size }) => textAreaContentLabelBottomPadding[$size]};
  position: relative;
  width: 100%;
  ${inputStateOutlineStyles.default};

  ${({ $hasError, $isDisabled, $isFocused, $isHighlighted, $isReadOnly, theme }) =>
    css`
      ${!$hasError && !$isDisabled && $isFocused && !$isReadOnly && inputStateOutlineStyles.focus}
      ${!$hasError && !$isDisabled && !$isFocused && $isHighlighted && !$isReadOnly && inputStateOutlineStyles.hover}
      ${$hasError && inputStateOutlineStyles.error}
      ${$hasError && $isFocused && inputStateOutlineStyles.errorAndFocus}
      ${$isReadOnly &&
      css`
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
      `}
      ${$isDisabled &&
      css`
        background-color: ${theme.color.state.default.disabled.value};
        border-color: transparent;
      `}
    `}

  &::placeholder {
    color: ${({ theme }) => theme.color.text.light.disabled.value};
  }
`;

export { TextAreaContentLabel };

TextAreaContentLabel.propTypes = {
  /** If true, use error styling */
  hasError: PropTypes.bool,
  /** Ff true, hide the label */
  hideLabel: PropTypes.bool,
  /** If true, use disabled styling */
  isDisabled: PropTypes.bool,
  /** If true, use focused styling */
  isFocused: PropTypes.bool,
  /** if true, use highlight styling */
  isHighlighted: PropTypes.bool,
  /** If true, use read only styling */
  isReadOnly: PropTypes.bool,
  /** Ff true, use required styling */
  isRequired: PropTypes.bool,
  /** Maximum allowed height before scrolling */
  maxInputHeight: PropTypes.number,
  /** The bottom padding between the input and the frame */
  size: PropTypes.string,
};
